
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clippath"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}})]),_c('style',[_v('.cls-3{fill:#ff3d3d}')])]),_c('g',{attrs:{"clip-path":"url(#clippath)"}},[_c('path',{staticClass:"cls-3",attrs:{"d":"M16.27 7.71c-.1-.1-.23-.15-.37-.15s-.27.06-.37.15l-3.54 3.54-3.73-3.73c-.2-.2-.53-.2-.74 0-.2.2-.2.53 0 .74l3.73 3.73-3.73 3.73c-.1.1-.15.23-.15.37s.06.27.15.37c.1.1.23.15.37.15.14 0 .27-.05.37-.15l3.73-3.73 3.54 3.54c.1.1.23.15.37.15a.514.514 0 00.52-.52c0-.14-.06-.27-.15-.37l-3.54-3.54 3.54-3.54c.2-.21.19-.53-.01-.74z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M12.01.75a11.245 11.245 0 00-7.95 19.2c4.39 4.39 11.52 4.39 15.91 0 4.39-4.39 4.39-11.52 0-15.91a11.19 11.19 0 00-7.95-3.3zm7.22 18.47c-3.98 3.98-10.45 3.98-14.43 0C.82 15.23.82 8.77 4.8 4.79 8.78.81 15.25.81 19.23 4.79c3.98 3.98 3.99 10.45 0 14.43z"}})])])
          )
        }
      }
    